import React, {  useState } from 'react'
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { styleObjectBlackButton, styleObjectGetAdminNavBG } from "../common/StyleSeter"

const Pagination = ({ currentPage, totalPages, visiblePages, handlePageClick, colorSchema }: any) => {
    const DD = useSelector((e: any) => e.domainDetails);
    const [goPageNum, setGoPageNum] = useState('');
    const [hoveredPage, setHoveredPage] = useState<number | null>(null);
      const navBgStyle = styleObjectGetAdminNavBG(
        DD?.adminNavSchema,
        DD?.adminNavSchema ? DD?.adminNavTextColor : DD?.colorSchema
      );

    // Defaults: at least 1 page, current page at least 1
    const safeTotalPages = totalPages > 0 ? totalPages : 1;
    const safeCurrentPage = currentPage > 0 ? currentPage : 1;

    // Fallback: if no pages are passed, show page 1 by default
    const pages: number[] =
        Array.isArray(visiblePages) && visiblePages.length > 0 ? visiblePages : [1];

    const isFirst = safeCurrentPage === 1;
    const isLast = safeCurrentPage === safeTotalPages;

    const handleGoToPage = () => {
        const page = Number(goPageNum);
        if (page > 0 && page <= safeTotalPages) {
            handlePageClick(page);
            // setGoPageNum('');
        } else if (page > safeTotalPages) {
            toast.error(`You can go up to ${safeTotalPages} pages only`);
            // setGoPageNum('');
            window.scrollTo(0, 0);
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.replace(/[^0-9]/g, '');
        setGoPageNum(value);
    };

    console.log({goPageNum})

    return (
        <div>
            <ul id="pageNumberContent" className="pages">
                <li id="prev">
                    <a
                        href="javascript:void(0);"
                        className="disable"
                        onClick={(e) => { e.preventDefault();  handlePageClick(safeCurrentPage - 1); }}
                        style={{
                            pointerEvents: isFirst ? "none" : "auto",
                            cursor: isFirst ? "not-allowed" : "pointer",
                            opacity: isFirst ? "0.6" : "1",
                        }}
                    >
                        Prev
                    </a>
                </li>

                {pages.map((page: number) => {
                    const isSelected = page === safeCurrentPage;
                    const isHovered = hoveredPage === page;
                    return (
                        <li key={page}>
                            <a
                                href="javascript:void(0);"
                                className={isSelected ? "select" : ""}
                                style={
                                    isSelected || isHovered
                                        ? {
                                         
                                      background: "rgb(255, 204, 46)",
                                        border: `1px solid #cb8009}`
                                          }
                                        : {
                                            border: "1px solid #bbb"
                                        }
                                }
                                onMouseEnter={() => setHoveredPage(page)}
                                onMouseLeave={() => setHoveredPage(null)}
                              onClick={(e) => { e.preventDefault(); if (isSelected) return; handlePageClick(page); }}
                            >
                                {page}
                            </a>
                        </li>
                    );
                })}

                <li id="next">
                    <a
                        href="javascript:void(0);"
                        className="disable"
                        onClick={(e) => { e.preventDefault(); handlePageClick(safeCurrentPage + 1); }}
                        style={{    
                            pointerEvents: isLast ? "none" : "auto",
                            cursor: isLast ? "not-allowed" : "pointer",
                            opacity: isLast ? "0.6" : "1",
                        }}
                    >
                        Next
                    </a>
                </li>

                <input
                    type="text"
                    id="goToPageNumber_1"
                    maxLength={6}
                    size={4}
                    value={goPageNum}
                    onChange={handleInputChange}
                    readOnly
                    onFocus={(e) => e.target.removeAttribute('readOnly')}
                    onBlur={(e) => e.target.setAttribute('readOnly', 'true')}
                    autoComplete="off"
                />
                <a
                    id="goPageBtn_1"
                    style={{
                                        ...styleObjectBlackButton(DD?.colorSchema,true),
                                            border: "1px solid #bbb",
                                      }}
                    onClick={(e) => { e.preventDefault(); handleGoToPage(); }}
                >
                    GO
                </a>
            </ul>
        </div>
    )
}

export default Pagination